export const ACTIVATE_TRIAL_COOKIE_NAME = 'activateTrial';
export const ACTIVATE_TRIAL_QUERY_PARAM = 'activateTrial';
